<template>
  <RCard class="evaluations relative-position">
    <Grid v-if="subscriptionPeriods.length" gtc="auto 1fr" gap="var(--r-space-xl)" class="full-height">
      <PeriodsSidebar
        :periods="subscriptionPeriods"
        :active-id="evaluation ? evaluation.id : null"
        @period-changed="getEvaluation"
      />

      <Grid v-if="evaluation" gtr="1fr auto" class="content">
        <Evaluations :evaluation="evaluation" />

        <Grid gaf="column" gap="var(--r-space-md)" justify-content="end" class="actions">
          <RBtn size="small" type="primary" @click="updateEvaluation(false)">Save</RBtn>

          <RBtn v-if="!evaluation.finalized" size="small" type="tertiary" @click="updateEvaluation(true)">
            Finalize
          </RBtn>
        </Grid>
      </Grid>
    </Grid>

    <QInnerLoading :showing="!subscriptionPeriods.length || requestInProgress">
      <QSpinnerHourglass size="3.5rem" color="primary-1" />
    </QInnerLoading>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
// Components
import PeriodsSidebar from '@/modules/show-page-subscription/shared/PeriodsSidebar'
import Evaluations from '@/reusable/evaluation-form/Evaluations'

export default {
  components: {
    Evaluations,
    PeriodsSidebar
  },

  props: {
    id: [Number, String]
  },

  data: () => ({
    requestInProgress: false,
    evaluation: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscriptionPeriods'])
  },

  watch: {
    subscriptionPeriods: {
      immediate: true,
      handler(newVal) {
        if (newVal.length) this.getEvaluation(newVal[0].id)
      }
    }
  },

  methods: {
    getEvaluation(periodId) {
      if (this.requestInProgress) return
      if (this.evaluation?.id === periodId) return

      this.requestInProgress = true

      apiTo
        .GET_SUBSCRIPTION_PERIOD_EVALUATION(periodId)
        .then(({ data }) => (this.evaluation = data.result))
        .finally(() => (this.requestInProgress = false))
    },

    updateEvaluation(finalized) {
      if (this.requestInProgress) return
      this.requestInProgress = true

      const evaluation = this.evaluation

      apiTo
        .UPDATE_SUBSCRIPTION_PERIOD_EVALUATION(evaluation.id, {
          content: evaluation.custom_form?.content ?? null,
          form_id: evaluation.custom_form?.form_id ?? null,
          finalized,
          note: evaluation.general_form.note.value,
          price_satisfaction: evaluation.general_form.price_satisfaction.value,
          usage_satisfaction: evaluation.general_form.usage_satisfaction.value,
          content_satisfaction: evaluation.general_form.content_satisfaction.value,
          recommendation: evaluation.general_form.recommendation.value
        })
        .then(({ data }) => (this.evaluation = data.result))
        .finally(() => (this.requestInProgress = false))
    }
  }
}
</script>
